module.exports = __webpack_public_path__ + "static/media/FarmCup.4d93e09b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/outskirts/themedEvent/FarmCup.png
// module id = 1335
// module chunks = 3